import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-client-property-dialog',
  templateUrl: './client-property-dialog.component.html',
  styleUrls: ['./client-property-dialog.component.css']
})
export class ClientPropertyDialogComponent implements OnInit {
  form!: FormGroup;
  title: string;

  date:          string;
  isRented?:     boolean;
  rentAmount?:   number;
  ownerName?:    string;
  managerName?:  string;
  contactPhone?: string;
  email?:        string;
  address?:      string;
  city?:         string;
  zipCode?:      string;
  unitNumber?:   string;
  bedrooms?:     number;
  bathrooms?:    number;
  latitude?:     any;
  longitude?:    any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ClientPropertyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data:any) {
      // Dynamic title for Add or Edit Property
      this.title = data.title;

      // If adding new property, use current date, if editing existing property then use original entry date
      if (!data.entryDate) {
        this.date = formatDate(Date.now(), 'shortDate', 'en-US');
      } else {
        this.date = data.entryDate;
      }

      this.isRented     = data.isRented;
      this.rentAmount   = data.rentAmount;
      this.ownerName    = data.ownerName;
      this.managerName  = data.managerName;
      this.contactPhone = data.contactPhone;
      this.email        = data.email;
      this.address      = data.address;
      this.city         = data.city;
      this.zipCode      = data.zipCode;
      this.unitNumber   = data.unitNumber;
      this.bedrooms     = data.bedrooms;
      this.bathrooms    = data.bathrooms;
      this.latitude     = data.latitude;
      this.longitude    = data.longitude;
    }

  ngOnInit() {
    this.form = this.fb.group({
        entryDate:    [this.date,         []],
        isRented:     [this.isRented,     []],
        rentAmount:   [this.rentAmount,   [Validators.min(0)]],
        ownerName:    [this.ownerName,    []],
        managerName:  [this.managerName,  []],
        contactPhone: [this.contactPhone, []],
        email:        [this.email,        []],
        address:      [this.address,      []],
        city:         [this.city,         []],
        zipCode:      [this.zipCode,      []],
        unitNumber:   [this.unitNumber,   []],
        bedrooms:     [this.bedrooms,     []],
        bathrooms:    [this.bathrooms,    []],
        latitude:     [this.latitude,     []],
        longitude:    [this.longitude,    []],
    });
  }

  save() {
      this.dialogRef.close(this.form.value);
  }

  close() {
      this.dialogRef.close();
  }
}
